import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { debounce } from '@cian/newbuilding-utils';
import { ROOM_TYPES_OPTIONS, FILTER_DEBOUNCE_TIME } from '../constants/filters';
import { mapFiltersToRequestParams } from '../mappers';
import { TrackingContext } from '../tracking/TrackingContext';
import { FiltersElements } from '../types/tracking';
export var useFloorPlanFilters = function useFloorPlanFilters(_ref) {
  var loadPlan = _ref.loadPlan,
    filters = _ref.filters,
    floors = _ref.floors;
  var _React$useContext = React.useContext(TrackingContext),
    onFilterClick = _React$useContext.onFilterClick;
  var loadPlanDebounced = React.useMemo(function () {
    return debounce(FILTER_DEBOUNCE_TIME, loadPlan);
  }, [loadPlan]);
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    houseId = _React$useState2[0],
    setHouseId = _React$useState2[1];
  var _React$useState3 = React.useState(null),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    sectionId = _React$useState4[0],
    setSectionId = _React$useState4[1];
  var _React$useState5 = React.useState([]),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    roomTypes = _React$useState6[0],
    setRoomTypes = _React$useState6[1];
  var _React$useState7 = React.useState(null),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    floorNumber = _React$useState8[0],
    setFloorNumber = _React$useState8[1];
  React.useEffect(function () {
    setHouseId(filters.houseId);
    setSectionId(filters.sectionId);
    setRoomTypes(filters.activeRoomType);
    setFloorNumber(filters.floorNumber);
  }, [filters]);
  var housesOptions = React.useMemo(function () {
    return filters.houses.map(function (house) {
      return {
        value: house.id,
        label: house.title
      };
    });
  }, [filters.houses]);
  var sectionsOptions = React.useMemo(function () {
    return filters.sections.map(function (section) {
      return {
        value: section.id,
        label: section.title
      };
    });
  }, [filters.sections]);
  var roomTypesOptions = React.useMemo(function () {
    return ROOM_TYPES_OPTIONS.map(function (type) {
      return _objectSpread(_objectSpread({}, type), {}, {
        disabled: !filters.availableRoomTypes.includes(type.value),
        checked: roomTypes.includes(type.value)
      });
    });
  }, [filters.availableRoomTypes, roomTypes]);
  var onHouseChange = function onHouseChange(val) {
    setHouseId(+val);
    setSectionId(null);
    setFloorNumber(null);
    setRoomTypes([]);
    onFilterClick(FiltersElements.Corpus);
    loadPlan(mapFiltersToRequestParams(_objectSpread(_objectSpread({}, filters), {}, {
      houseId: +val,
      sectionId: null,
      floorNumber: null,
      activeRoomType: []
    })));
  };
  var onSectionChange = function onSectionChange(val) {
    setSectionId(+val);
    setFloorNumber(null);
    setRoomTypes([]);
    onFilterClick(FiltersElements.Section);
    loadPlan(mapFiltersToRequestParams(_objectSpread(_objectSpread({}, filters), {}, {
      sectionId: +val,
      floorNumber: null,
      activeRoomType: []
    })));
  };
  var onFloorChange = function onFloorChange(val) {
    setFloorNumber(val);
    onFilterClick(FiltersElements.Level);
    loadPlan(mapFiltersToRequestParams(_objectSpread(_objectSpread({}, filters), {}, {
      floorNumber: val
    })));
  };
  var onRoomTypesChange = function onRoomTypesChange(type) {
    return function (e, value) {
      var roomTypesSet = new Set(roomTypes);
      if (value) {
        roomTypesSet.add(type);
      } else {
        roomTypesSet.delete(type);
      }
      setRoomTypes(Array.from(roomTypesSet));
      onFilterClick(FiltersElements.Layout);
      loadPlanDebounced(mapFiltersToRequestParams(_objectSpread(_objectSpread({}, filters), {}, {
        activeRoomType: Array.from(roomTypesSet)
      })));
    };
  };
  return {
    houseId: houseId,
    sectionId: sectionId,
    housesOptions: housesOptions,
    sectionsOptions: sectionsOptions,
    roomTypesOptions: roomTypesOptions,
    onHouseChange: onHouseChange,
    onSectionChange: onSectionChange,
    onRoomTypesChange: onRoomTypesChange,
    floorNumber: floorNumber,
    floors: floors,
    onFloorChange: onFloorChange
  };
};